import { submission } from "../../graphql"
import { graphqlApolloClient } from "../graphql-apollo-client"

const getMonitoringReportsParticipantsBySubmission = async ({ id }) => {
  const { data } = await graphqlApolloClient.query({
    query: submission.queries.getMonitoringReportsParticipantsBySubmissionQuery,
    fetchPolicy: "network-only",
    variables: {
      id
    }
  })

  return data?.MonitoringReportsParticipantsBySubmission
}

export const MonitoringReportsParticipantsServices = {
  getMonitoringReportsParticipantsBySubmission
}